import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { EnfafModalComponent } from '../../../../../components/enfaf-modal/enfaf-modal.component';
import { ApiService } from '../../../../../core/services/api/api.service';
import { ToastService } from '../../../../../core/services/toast/toast.service';

export interface ModalIssueDiplomaData {
  courseId: string;
  userId: string;
  courseName: string;
}

@Component({
  selector: 'app-modal-issue-diploma',
  standalone: true,
  imports: [EnfafModalComponent],
  templateUrl: './modal-issue-diploma.component.html',
  styleUrl: './modal-issue-diploma.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalIssueDiplomaComponent {
  protected readonly data = inject<ModalIssueDiplomaData>(MAT_DIALOG_DATA);
  protected isSending = false;

  private readonly dialogRef = inject(MatDialogRef<ModalIssueDiplomaComponent>);
  private readonly api = inject(ApiService);
  private readonly toast = inject(ToastService);
  private readonly cdr = inject(ChangeDetectorRef);

  protected async onConfirm(): Promise<void> {
    if (this.isSending) {
      return;
    }

    this.isSending = true;
    this.cdr.markForCheck();

    try {
      await firstValueFrom(
        this.api.issueAndSendCourseDiploma({
          userId: this.data.userId,
          courseId: this.data.courseId
        })
      );
      this.dialogRef.close({ issue: true });
    } catch (error: any) {
      this.toast.presentErrorToast(error?.error?.message || 'Hubo un error al expedir y enviar el diploma');
    } finally {
      this.isSending = false;
      this.cdr.markForCheck();
    }
  }

  protected onClose(): void {
    this.dialogRef.close();
  }
}
